import { InvoiceSettingsForm } from '../../../types/invoiceSettingsForm'

// Manually updating list of those fields in InvoiceSettingsForm won't update live settings preview
export const invoiceSettingsFormIgnoredLivePreviewFields: (keyof InvoiceSettingsForm)[] = [
  'automaticPaymentRemindersSettings',
  'legalMentions',
  'legalFormSettings',
  // Doubling the request when loading logo. It still requesting live preview using logoId
  'logoUrl',
]
